<template>
  <div class="date-range-picker">
    <button class="btn btn-primary" @click="toggleDateRangePicker">{{ dateRangeLabel }} <i class="fa fa-chevron-down"></i></button>
    
    <!-- 下拉選單部分 -->
    <div v-if="isPickerVisible" class="date-picker-popup">
      <div class="date-picker-content">
        <!-- 預設範圍選項 -->
        <div v-if="!showCustom" class="predefined-ranges">
          <button
            v-for="range in predefinedRanges"
            :key="range.value"
            class="range-btn"
            @click="range.value === 'custom' ? showCustomPicker() : selectPredefinedRange(range)"
          >
            {{ range.label }}
          </button>
        </div>
        
        <!-- 當選擇了自定義日期範圍時，顯示日期選擇器 -->
        <div v-if="showCustom" class="custom-range-picker">
          <Datepicker v-model="customDateRange" inline range :auto-apply="true" :enable-time-picker="false" />
          <div class="actions">
            <button class="btn btn-primary" @click="cancelCustomRange">Cancel</button>
            <button class="btn btn-primary" @click="applyCustomRange">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useReportStore } from '@/store/driver/report';

const reportStore = useReportStore();
const isPickerVisible = ref(false);
const dateRangeLabel = ref('This month');
const showCustom = ref(false);  // 控制顯示自定義日期選擇器
const customDateRange = ref([new Date(), new Date()]);

const predefinedRanges = [
  { label: 'This week', value: 'this_week' },
  { label: 'Last week', value: 'last_week' },
  { label: 'This month', value: 'this_month' },
  { label: 'Last month', value: 'last_month' },
  { label: 'Custom', value: 'custom' },
];

const toggleDateRangePicker = () => {
  isPickerVisible.value = !isPickerVisible.value;
};

const showCustomPicker = () => {
  showCustom.value = true;  // 顯示自定義日期選擇器
};

// 當選擇預設範圍時，立即調用 API
const selectPredefinedRange = async (range) => {
  await reportStore.fetchReportInfo(range.value);  // 調用 API，傳遞預設的 period
  dateRangeLabel.value = range.label;
  isPickerVisible.value = false;
};

// 當使用者確定自定義範圍後調用 API
const applyCustomRange = async () => {
  if (customDateRange.value.length === 2) {
    const [start, end] = customDateRange.value;
    dateRangeLabel.value = `${formatDate(start)} - ${formatDate(end)}`;

    // 調用 API，傳遞自定義日期範圍
    await reportStore.fetchReportInfo('custom', formatDate(start), formatDate(end));

    showCustom.value = false;  // 關閉自定義日期選擇器
    isPickerVisible.value = false;
  }
};

// 取消自定義日期選擇
const cancelCustomRange = () => {
  showCustom.value = false;  // 取消自定義範圍，回到預設選項
};

// 格式化日期
const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};
</script>

<style scoped>
.btn-primary{
  border-radius: 30px;
  font-size: 16px;
}

.date-range-picker {
  position: relative;
}

.date-picker-popup {
  position: absolute;
  margin-top: 10px;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #5148da;
  padding: 20px;
  z-index: 1050;
  min-width: 320px;
  min-height: 280px;
}

.date-picker-content {
  display: flex;
  flex-direction: column;
}

.predefined-ranges {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.range-btn {
  margin-bottom: 5px;
  width: auto;
  background-color: white;
  color: #8476f4;
  border: 2px solid #8476f4;
  padding: 10px;
  cursor: pointer;
  border-radius: 20px;
  text-align: center;
}

.range-btn:hover {
  background-color: #9e98ea;
}

.custom-range-picker {
  position: relative;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.actions .btn {
  margin-left: 10px;
}
</style>
